import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [TableModule, CommonModule, ToggleButtonModule, FormsModule, TooltipModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class TableComponent {
  @Input() data: any[] = [];
  @Input() columns: any[] = [];
  @Input() options: any = {};
  @Output() editRow = new EventEmitter<any>();
  @Output() viewRow = new EventEmitter<any>();
  @Output() copyRow = new EventEmitter<any>();  
  @Output() paginationInfo = new EventEmitter<any>();
  @Output() searchInfo = new EventEmitter<any>();
  @Output() addData = new EventEmitter<any>();
  @Output() exportData = new EventEmitter<any>();
  @Output() searchClear = new EventEmitter<any>();
  public loading = false;
  public pagination = true;
  public rows = 25;
  public first = 0;
  public rowsPerPage = [10, 25, 50, 100];
  public totalRecords: any;
  public searchText: any = '';
  public isSearched: boolean = false;
  public sortField = '';
  public sortOrder = 1;

  constructor() { }

  ngOnInit() {
    this.totalRecords = this.options?.totalRecords || this.data?.length;
    this.rows = this.options?.rows || this.rows;
    this.pagination = this.options?.pagination || this.pagination;
    this.first = this.options?.first || this.first;
  }

  ngOnChanges() {
    this.totalRecords = this.options?.totalRecords || this.data?.length;
    this.rows = this.options?.rows || this.rows;
    this.first = this.options?.first;
  }

  loadMoreData(event: any) {
    this.first = event.first;
    
    this.paginationInfo.emit(event);
  }

  onSort(event: any){
    this.sortField = event.field;
    this.sortOrder = event.order;
  }

  editData(data: any) {
    this.editRow.emit(data);
  }

  copyData(data: any) {
    this.copyRow.emit(data);
  }

  viewData(data: any) {
    this.viewRow.emit(data);
  }

  searchValue(val: any) {
    this.isSearched = true;
    this.searchInfo.emit(val);
  }

  clearSearch(searchField: any) {
    this.searchText = "";
    searchField.value = "";
    if (this.isSearched) {
      this.isSearched = false;
      this.searchClear.emit();
    }
  }

  downloadFile() {
    this.exportData.emit();
  }

  addDataClick() {
    this.addData.emit();
  }

}
